module.exports = {"private":true,"version":"3.12.5","name":"kinvey-phonegap-sdk","description":"Kinvey JavaScript SDK for Cordova/PhoneGap applications.","author":"Kinvey, Inc.","homepage":"http://www.kinvey.com","license":"Apache-2.0","main":"kinvey-phonegap-sdk.min.js","scripts":{"prebuild":"rm -rf dist","build":"webpack --config webpack.config.js","release":"npm run build -- --env.uglify && ./scripts/push.sh","postrelease":"rm -rf tmp","s3":"npm run build -- --env.uglify --env.s3"},"files":["kinvey-phonegap-sdk.min.js","kinvey-phonegap-sdk.min.js.map"]}


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 532
// module chunks = 0